import { LicenseInfo } from '@mui/x-license-pro'

const setLicenseKey = () => {
    LicenseInfo.setLicenseKey('d1227ca01c4b3bf249bac45bffdb6a8dTz01NDQyMyxFPTE3MDAxNTYxMjcwNjQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
}

export default setLicenseKey 
